
export const HEADER_HEIGHT = 65;

export class Shared {

	static isPositionStickySupported() {
		if (this.positionStickySupported !== undefined) {
			return this.positionStickySupported;
		} else {
			const property = 'position:';
			const value = 'sticky';
			const prefixes = ['', '-webkit-', '-moz-', '-o-', '-ms-'];
			const element = document.createElement('a');
			const style = element.style;
			style.cssText = property + prefixes.join(value + ';' + property).slice(0, -property.length);
			const supported = style.position.indexOf(value) !== -1;
			this.positionStickySupported = supported;
			return supported;
		}
	}

}
